import React, { forwardRef, useId } from 'react';
    import { cn } from '@/lib/utils';

    const Input = forwardRef(({ className, label, error, name, id: providedId, ...props }, ref) => {
      const generatedId = useId();
      const id = providedId || generatedId;

      return (
        <div className="w-full space-y-1.5">
          {label && (
            <label 
              htmlFor={id} 
              className="text-sm font-medium text-slate-700 dark:text-slate-300"
            >
              {label}
            </label>
          )}
          <input
            ref={ref}
            id={id}
            name={name || id}
            className={cn(
              "flex h-10 w-full rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-3 py-2 text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200 dark:text-white",
              error && "border-red-500 focus:ring-red-500/20 focus:border-red-500",
              className
            )}
            {...props}
          />
          {error && <p className="text-xs text-red-500 font-medium">{error}</p>}
        </div>
      );
    });

    Input.displayName = 'Input';
    export { Input };